import React from 'react';
import { Link } from 'react-router-dom';
import NavItem from '../NavItem/NavItem';

const NavItemLogo = ({
  src,
  path,
}) => {
  return (
    <NavItem>
      <div className="c-side-menu__nav-item--logo-wrp">
        <Link to={`/console${path || ''}`}>
          <img src={src} alt="logo" />
        </Link>
      </div>
    </NavItem>
  );
};

export default NavItemLogo;



// WEBPACK FOOTER //
// ./src/components/IterioApp/sideMenu/components/NavItemLogo/NavItemLogo.jsx